import React, { useContext } from 'react';
import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { SpinnerArea, Table, TablePagination } from '../../../shared/components';
import operationService from '../../../services/operationService';
import useServiceReducer from '../../../shared/hooks/useServiceReducer';
import { OperationGrievance, QueryGroup } from '../../../services/types/Operation';
import { Cell } from '../../../shared/components/Table';
import { dateStr } from '../../../shared/misc/utils';
import OperationContext from './context';

import StatusBadge from '../../MiciCases/StatusBadge';
import grievanceReducer from './grievanceReducer';
import {
  GRIEVANCE_STATUSES,
  GrievanceFilter,
  QuerySubGroup,
} from '../../../services/types/Grievance';
import { GRIEVANCE_PHASES } from '../../Grievances/constants';

// import grievanceReducer from '../../Grievances/GrievanceReducer';

const Grievances: React.FC = () => {
  const {
    operation: { id, number },
  } = useContext(OperationContext);

  const initFilter: GrievanceFilter = {
    operationId: id,
    pageNumber: 1,
    sortField: 'number',
    sortDescending: false,
    queryGroup: QueryGroup.All,
    querySubGroup: QuerySubGroup.All, // no use in tabs
    pageSize: 0, // no use in tabs
    hiddenColumns: [], // no use in tabs
  };

  const [data, loading, filter, dispatch] = useServiceReducer(
    operationService.getGrievances,
    grievanceReducer,
    initFilter
  );

  const { t } = useTranslation();

  const pageSize = 8;
  const changePage = (page: number) => dispatch({ type: 'PAGE', value: page });
  const changeSort = (column: string, descending: boolean) =>
    dispatch({ type: 'ORDER', column, descending });

  const cells: Cell<OperationGrievance>[] = [
    {
      name: 'number',
      value: (x) => x.number,
      render: (x, o) => (
        <Link
          to={
            id
              ? `/grievance-protocol/details/${o.number}?operationNumber=${number}`
              : `/grievance-protocol/`
          }
        >
          {x}
        </Link>
      ),
      column: 'grievanceNumber',
    },
    {
      name: 'status',
      value: (x) =>
        x.status === GRIEVANCE_STATUSES.NOT_APPLICABLE
          ? t('grievanceStagesGrid.NotApplicable').toString()
          : t(`grievanceStagesGrid.${x.status}`).toString(),
      column: 'grievanceStatus',
      render: (x) => <StatusBadge code={x} />,
    },
    {
      name: 'phase',
      value: (x) =>
        x.phase === GRIEVANCE_PHASES.NOT_APPLICABLE
          ? ''
          : t(`grievanceStagesGrid.${x.phase}`).toString(),
      column: 'grievancePhase',
    },
    {
      name: 'registrationDate',
      value: (x) => dateStr(x.registrationDate),
    },
  ];

  return (
    <SpinnerArea loading={loading}>
      {data && data.total > 0 && (
        <>
          <Table
            data={data.list}
            cells={cells}
            keyFunc={(x) => x.id}
            sortData={filter}
            changeSort={changeSort}
          />
          <TablePagination
            pageSize={pageSize}
            pageNumber={filter.pageNumber}
            total={data.total}
            onChangePage={changePage}
          />
        </>
      )}
    </SpinnerArea>
  );
};

export default Grievances;
